// Carga bajo demanda del SDK de Facebook, para el Embedded Signup de WhatsApp (F1-4a-2).
//
// 🔴 POR QUE BAJO DEMANDA Y NO EN public/index.html: el panel entero no debe depender de
// connect.facebook.net. Si Meta esta caido, si el dominio no esta autorizado o si el usuario tiene
// un bloqueador, TODO menos el tab Canales tiene que seguir funcionando -- la agenda, el CRM, la
// bandeja. Un <script> en el HTML acopla la carga de la aplicacion a un tercero para una funcion
// que la mayoria de las sesiones no va a usar nunca.
//
// Mismo criterio que el AudioContext de Inbox.js: se aisla el recurso externo para que su ausencia
// sea VISIBLE y no rompa el resto. La diferencia es que aqui el recurso viaja por red, asi que
// ademas hace falta un tope de tiempo -- ver abajo.
//
// PRECEDENTE: no habia. Este es el primer script de terceros que carga este frontend; antes de
// F1-4a-2 no existia ni un createElement("script") en todo src/ (verificado por grep).

// Valores PUBLICOS, no secretos: viajan al navegador de cualquier forma, van en la URL del popup de
// Meta y son visibles en el bundle. Hardcodeados a proposito, siguiendo el patron del repo para
// configuracion publica (AGENCY_API en Onboarding.js, el telefono de soporte, la URL del widget).
// La alternativa, REACT_APP_*, obligaria a tocar deploy-frontend.yml -- frontend/.env esta
// gitignorado, asi que la variable no viaja en el repo y el workflow la inyecta como literal.
const APP_ID = "988837167219182";
export const CONFIG_ID = "1228686752754505";

// 🔴 v25.0 es la version del SDK del NAVEGADOR. NO confundir con la v23.0 que usa agency en sus
// llamadas server-to-server a la Graph API: son dos superficies distintas y se versionan aparte.
const GRAPH_VERSION = "v25.0";

const SDK_SRC = "https://connect.facebook.net/en_US/sdk.js";
const SCRIPT_ID = "facebook-jssdk";

// 🔴 EL TOPE DE TIEMPO ES LO QUE HACE VISIBLE EL FALLO. Sin el, el modo de falla tipico --dominio
// no autorizado en la app de Meta, bloqueador de anuncios, red caida-- produce un boton que no hace
// NADA: no lanza excepcion, no pinta error, simplemente nunca resuelve. El usuario pulsa y no pasa
// nada, y desde soporte es indistinguible de "no le funciona". Con el tope, eso se convierte en un
// mensaje concreto.
const TIMEOUT_MS = 10000;

export class FacebookSdkError extends Error {
  constructor(mensaje) {
    super(mensaje);
    this.name = "FacebookSdkError";
  }
}

// Memo de la promesa: el helper es idempotente y el <script> se inserta UNA sola vez por pestaña.
// Se pone a null en los caminos de fallo para que un reintento del usuario vuelva a intentarlo.
let promesaCarga = null;

export function loadFacebookSdk() {
  if (promesaCarga) return promesaCarga;

  promesaCarga = new Promise((resolve, reject) => {
    // Si el SDK ya esta listo (segunda entrada al tab, o un reintento despues de un timeout que
    // en realidad llego tarde), no hay nada que cargar.
    if (window.FB) {
      resolve(window.FB);
      return;
    }

    const temporizador = setTimeout(() => {
      promesaCarga = null;
      reject(
        new FacebookSdkError(
          "No se pudo cargar el conector de Meta. Puede ser un bloqueador de anuncios, la red, " +
            "o que el dominio no esté autorizado. Vuelve a intentarlo."
        )
      );
    }, TIMEOUT_MS);

    // El SDK llama a esta funcion global cuando termina de inicializarse.
    window.fbAsyncInit = () => {
      window.FB.init({
        appId: APP_ID,
        version: GRAPH_VERSION,
        autoLogAppEvents: true,
        xfbml: true,
      });
      clearTimeout(temporizador);
      resolve(window.FB);
    };

    let etiqueta = document.getElementById(SCRIPT_ID);
    if (!etiqueta) {
      etiqueta = document.createElement("script");
      etiqueta.id = SCRIPT_ID;
      etiqueta.src = SDK_SRC;
      etiqueta.async = true;
      etiqueta.defer = true;
      etiqueta.crossOrigin = "anonymous";
      // onerror cubre el fallo RAPIDO (dominio bloqueado, DNS). El temporizador cubre el fallo
      // LENTO (la peticion se queda colgada), que es el que no dispara ningun evento.
      etiqueta.onerror = () => {
        clearTimeout(temporizador);
        promesaCarga = null;
        reject(new FacebookSdkError("No se pudo cargar el conector de Meta. Revisa tu conexión."));
      };
      document.body.appendChild(etiqueta);
    }
  });

  return promesaCarga;
}
